import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {CartService} from '../../shared/services/cart.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {DataService} from '../../shared/services/data.service';
import {AppConstants} from '../../shared/constants/app-constant';

@Component({
    selector: 'app-cart',
    templateUrl: './cart.component.html',
    styleUrls: ['./cart.component.scss']
})
export class CartComponent implements OnInit {
    showSearch = false;
    searchForm: FormGroup;
    cartProducts: any = [];
    submitting: any = false;
    selectedProduct: any;
    grandTotalAmount: any = 0;
    imageBaseUrl: any = AppConstants.BUCKET_URL;
    @ViewChild('content') templateRef: TemplateRef<any>;
    pagination = {
        page: 1,
        total: null,
        perpage: 15,
        pages: null
    };

    constructor(private fb: FormBuilder,
                private cartService: CartService,
                public modalService: NgbModal,
                private dataService: DataService,
                private router: Router) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'name': [''],
            'quantity': ['']
        });
        this.get();
    }

    get(params: any = {}) {
        params = {
            'page': -1,
            ...this.searchForm.value
        };
        this.submitting = true;
        this.cartProducts = [];
        this.cartService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.cartProducts = data['data'];
                let grandTotalAmount = 0;
                this.cartProducts.forEach(carProduct => {
                    carProduct['tax_amount'] = ((parseFloat(carProduct['distributed_price']) * parseFloat(carProduct['tax'])) / 100) * parseFloat(carProduct['quantity']);
                    carProduct['unit_tax_amount'] = ((parseFloat(carProduct['distributed_price']) * parseFloat(carProduct['tax'])) / 100);
                    carProduct['amount'] = ((parseFloat(carProduct['distributed_price'])) * parseFloat(carProduct['quantity']));
                    carProduct['total_amount'] = ((parseFloat(carProduct['amount'])) + parseFloat(carProduct['tax_amount']));
                    grandTotalAmount = grandTotalAmount + carProduct['total_amount'];
                });
                this.grandTotalAmount = grandTotalAmount;
            }
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    removeCartConfrimation(content, product) {
        this.selectedProduct = product;
        this.modalService.open(content, {'size': 'sm'});
    }

    removeFromCart() {
        this.cartService.delete(this.selectedProduct.product.id).subscribe(data => {
            this.dataService.sendMessage('GET_CART_ITEMS');
            this.modalService.dismissAll('');
            this.get();
        }, error => {
            this.submitting = false;
        });
    }

    search() {
        const params = {
            'name': (this.searchForm.value && this.searchForm.value.name) ? this.searchForm.value.name : '',
            'quantity': (this.searchForm.value && this.searchForm.value.quantity) ? this.searchForm.value.quantity : ''
        };
        this.get(params);
    }

    changeItemQuantiy(product, type) {
        let updatable = false;
        if (type === 'PLUS') {
            product['quantity'] = parseInt(product['quantity']) + 1;
            updatable = true;
        } else {
            if (parseInt(product['quantity']) === 1) {
                this.removeCartConfrimation(this.templateRef, product);
            } else {
                product['quantity'] = parseInt(product['quantity']) - 1;
                updatable = true;
            }
        }
        if (updatable) {
            this.cartService.update(product.unique_id, {'quantity': product['quantity']}).subscribe(data => {
                this.get();
            }, error => {
                this.submitting = false;
            });
        }
    }

    updateItemQuantity(event, product) {
        let productQuantity = event.target.value;
        if (parseInt(productQuantity) > 0) {
            this.cartService.update(product.unique_id, {'quantity': productQuantity}).subscribe(data => {
                this.get();
            }, error => {
                this.submitting = false;
            });
        } else {
            this.removeCartConfrimation(this.templateRef, product);
        }
    }

    checkout() {
        this.router.navigateByUrl('checkout');
    }
}
